module.exports = __webpack_public_path__ + "img/2-4.f4618137.png";